import PropTypes from 'prop-types';
import {Component} from 'react';
import LoadingPanel from './LoadingPanel/LoadingPanel';
import {Form, TextArea} from 'semantic-ui-react';
import './AgentNotes.scss';
import EditableTitle from './EditableTitle';
import InformationTip from './InformationTip';
import TextMeasurer from './TextMeasurer';

const listMaxCharacters = 400;
const featuredReportPageLimits = {
  width: 283,
  lines: 12,
};

export default class AgentNotes extends Component {
  static propTypes = {
    isLoading: PropTypes.bool,
    featureFlags: PropTypes.shape({
      rapidSearchEnabled: PropTypes.bool,
    }),
    reportPage: PropTypes.oneOf(['list', 'feature']),
    propertySelected: PropTypes.bool.isRequired,
    notes: PropTypes.string.isRequired,
    notesTitle: PropTypes.string,
    notesSelected: PropTypes.bool.isRequired,
    hideNotesSelected: PropTypes.bool,
    enabled: PropTypes.bool.isRequired,
    showFeatureProperty: PropTypes.bool.isRequired,
    featured: PropTypes.bool.isRequired,
    onAddFeature: PropTypes.func.isRequired,
    onFetchNotes: PropTypes.func.isRequired,
    onRemoveFeature: PropTypes.func.isRequired,
    onNotesChange: PropTypes.func.isRequired,
    onNotesSelected: PropTypes.func.isRequired,
    onNotesTitleChange: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      hasFetched: false,
      initialValue: props.notes,
      value: props.notes,
      editNote: props.notesSelected || props.featured,
      lines: 0,
    };
  }

  componentDidMount() {
    if (!this.state.hasFetched) {
      this.onFetchNotes();
      this.setState({hasFetched: true});
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if ((this.state.editNote && !prevState.editNote)) {
      setTimeout(() => {
        if (this._textarea) {
          this._textarea.focus();
        }
      }, 100);
    }
    if (this.props.notes !== prevProps.notes) {
      const {notes} = this.props;
      this.setState({
        initialValue: notes,
        value: notes,
      });
    }
  }

  componentWillUnmount() {
    this.onBlur();
  }

  notesSelected = () => {
    const {onNotesSelected, notesSelected} = this.props;
    let newValue = !notesSelected;
    onNotesSelected(newValue);
    this.setState({editNote: newValue});
  };

  toggleEdit = () => {
    const {editNote} = this.state;
    if (!editNote) {
      this.setState({editNote: true});
    } else {
      this._textarea.focus();
    }
  };

  onChange = (e, {value}) => {
    this.setState({value});
  };

  onFetchNotes = () => {
    const {featureFlags, notes, onFetchNotes} = this.props;
    if (featureFlags.rapidSearchEnabled && !notes) {
      onFetchNotes();
    }
  };

  onBlur = () => {
    const {onNotesChange} = this.props;
    const {value, initialValue} = this.state;
    if (value !== initialValue) {
      onNotesChange(value);
      this.setState({initialValue: value, editNote: false});
    } else {
      this.setState({editNote: false});
    }

  };

  onFeatureClick = () => {
    const {featured, onAddFeature, onRemoveFeature, notesSelected} = this.props;
    if (featured) {
      onRemoveFeature();
      if (!notesSelected) {
        this.setState({editNote: false});
      }
    } else {
      onAddFeature();
      this.setState({editNote: true});
    }
  };

  updateNotesTitle = (data) => {
    const {onNotesTitleChange} = this.props;
    onNotesTitleChange(data.title);
  };

  render() {
    const {
      isLoading,
      reportPage = 'list',
      notesSelected,
      hideNotesSelected,
      propertySelected,
      enabled,
      showFeatureProperty,
      featured,
      notesTitle,
    } = this.props;
    const {value, lines, editNote} = this.state;
    if (!enabled) {
      return null;
    }
    const editNoteText = notesSelected || featured || editNote;
    const error = featured ?
      lines >= featuredReportPageLimits.lines :
      value.length > listMaxCharacters;
    return (
      <LoadingPanel isLoading={isLoading}>
        <div>
          {propertySelected && <div className="agent-notes">
            <div className="header">
              {!hideNotesSelected && (
                <Form.Checkbox className="notes" checked={notesSelected} onClick={this.notesSelected}
                               disabled={featured}/>
              )}
              <div className="agent-notes-title">
                <EditableTitle onUpdateData={this.updateNotesTitle}
                               title={notesTitle}
                               isEnabled={true}
                               editFontSize="14px"
                               width="200.33px"
                               maxLength={32}/>
              </div>
              {showFeatureProperty && (
                <div className="feature-property">
                  <Form.Checkbox onClick={this.onFeatureClick} label="Feature this comparable" checked={featured}/>
                  <InformationTip>
                    <div>Please edit your feature property on the Customise Report page</div>
                  </InformationTip>
                </div>
              )}
            </div>
            <div>
              <div className="notes-text-container">
                {editNoteText ? (
                  <TextArea
                    autoHeight rows={4}
                    onChange={this.onChange}
                    onBlur={this.onBlur}
                    ref={(ref) => this._textarea = ref}
                    className={`notes-textarea ${error ? 'error' : ''}`}
                    value={value}
                  />
                ) : value && (
                  <div className={`notes-text ${error ? 'error' : ''}`} onClick={this.toggleEdit}>
                    {value && value.length > 200 && reportPage === 'list' ? `${value.slice(0, 200)}...` : value}
                  </div>
                )}
                <span className={`line-count ${error ? 'error' : ''}`}>
          {error ?
            'Notes are too long' : (featured ?
              `${featuredReportPageLimits.lines - lines - 1} lines remaining` :
              `${listMaxCharacters - value.length} characters remaining`)}
          </span>
              </div>
            </div>
            {featured && (
              <TextMeasurer
                text={value}
                width={featuredReportPageLimits.width}
                onLinesChange={(newLines) => this.setState({lines: newLines})}
              />
            )}
          </div>}
        </div>
      </LoadingPanel>
    );
  }
}
